









































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import OutfitClassifyApi from '@/api/goods/outfitClassify/index'
import CustomForm from '@/components/custom-form/index.vue'
@Component({
  components: { CustomForm },
})
export default class SelectOutfitModal extends AbpBase {
  @Prop({
    type: Boolean,
    default: false,
  })
  show!: boolean

  @Watch('show')
  showChange(show) {
    this.modal1 = !this.modal1
  }

  modal1: boolean = false
  total: number = 0
  pageSize: number = 10
  pageIndex: number = 1
  data = []

  filters = [
    {
      label: '输入搜索：',
      type: 'input',
      props: {
        placeholder: '套装分组名称',
      },
      key: 'keyWord',
    },
  ]

  columns: any[] = [
    {
      title: '分组名称',
      key: 'groupName',
      align: 'center',
    },
    // {
    //   title: '活动类型',
    //   key: 'activityTypeDisplayName',
    //   align: 'center',
    // },
    {
      title: '创建时间',
      slot: 'creationTime',
      align: 'center',
    },
    // {
    //   title: '活动结束时间',
    //   slot: 'endTime',
    //   align: 'center',
    // },
    // {
    //   title: '活动状态',
    //   key: 'activityStatus',
    //   align: 'center',
    // },
  ]

  async mounted() {}
  @Watch('modal1')
  async modalShowChange(show) {
    if (show) await this.getPageList()
  }

  async getPageList() {
    let form: any = this.$refs.lineForm
    const formData = (form && form.getForm()) || { keyWord: '' }
    await OutfitClassifyApi.getAllOutfitList(this.pageIndex, this.pageSize, formData.keyWord).then((res) => {
      this.total = res.data.totalCount
      this.data = res.data.items
    })
  }

  async onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
    await this.getPageList()
  }

  submitChange(form, valid) {
    if (valid) {
      this.getPageList()
    }
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  currentChange(currentRow, oldCurrentRow) {
    if (currentRow.activityStatus != '活动已下架') {
      this.$emit('on-row-selected', currentRow)
      console.log('aaaa', currentRow)
      this.modal1 = false
    } else {
      this.$Notice.warning({
        desc: '不能选择已下架的活动',
      })
    }
  }

  cancelFn() {
    this.$emit('on-row-selected', null)
    this.modal1 = false
  }
}
